export default "__VITE_ASSET__DV5n1oNi__"